module.exports = __webpack_public_path__ + "static/media/pprematrimoniales.8dd8c4f4.png";